import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozWeight'
})
export class BringozWeightPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService, @Inject('splitService') private splitService) {
  }

  transform(weight: number, enableUnitDisplay?: boolean, defaultValue: string = '--', isShortUnitDisplayName?: boolean, toFixed: number = 3): string {
    if (_.isUndefined(weight) || _.isNull(weight)) {
      return defaultValue;
    }

    const siteUnit = !!isShortUnitDisplayName ? this.splitService.getShortWeightUnit()
      : this.splitService.getWeightUnit();
    const calculatedWeight = weight.toFixed(Number.isInteger(weight) ? 0 : toFixed);
    const weightUnit = this.translateService.instant(`WEIGHT_UNIT.${siteUnit}`);
    return calculatedWeight + (enableUnitDisplay ? (' ' + weightUnit) : '');
  }
}
